import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { TariffMode, CategoryGroup } from "@/types/base";

interface SelectedLayerState {
  tariffLayer: TariffMode;
  adminTariffLayer: TariffMode;
  serviceLayer: CategoryGroup;
  setTariffLayer: (layer: TariffMode) => void;
  setAdminTariffLayer: (layer: TariffMode) => void;
  setServiceLayer: (layer: CategoryGroup) => void;
  getLayer: (isAdmin?: boolean) => TariffMode;
}

export const useTariffLayer = create<SelectedLayerState>()(
  persist(
    (set, get) => ({
      tariffLayer: "t_econom",
      adminTariffLayer: "t_econom",
      serviceLayer: "taxi",
      setTariffLayer: (tariffLayer) => set({ tariffLayer }),
      setAdminTariffLayer: (adminTariffLayer) => set({ adminTariffLayer }),
      setServiceLayer: (serviceLayer) => set({ serviceLayer }),
      getLayer: () => get().tariffLayer,
    }),
    {
      name: "selected-tariff-storage-v2",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
